import { render, staticRenderFns } from "./GlobalDishesModal.vue?vue&type=template&id=361581b1&"
import script from "./GlobalDishesModal.vue?vue&type=script&lang=js&"
export * from "./GlobalDishesModal.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDishesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports